export function useAuthUser() {
    const favouriteUnits = ref(null)

    const addtoFavourite = async (unitId: number) => {
        const { $auth } = useNuxtApp()

        const { API_URL } = useAPI()
        await $fetch(`${API_URL}me/favorites/${unitId}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${($auth as { token: string }).token}`
            }
        })
    }

    const removeFromFavourite = async (unitId: number) => {
        const { $auth } = useNuxtApp()

        const { API_URL } = useAPI()
        await $fetch(`${API_URL}me/favorites/${unitId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${($auth as { token: string }).token}`
            }
        })
    }

    const fetchFavouriteUnits = async () => {
        const { $auth } = useNuxtApp()

        const { API_URL } = useAPI()
        const units = await $fetch(`${API_URL}me/favorites?building.project`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${($auth as { token: string }).token}`
            }
        })

        favouriteUnits.value = units
    }

    const isUnitFavourite = computed(() => {
        return (unitId: number) => {
            if (!favouriteUnits.value) {
                return false
            }
            return favouriteUnits.value.some((unit: { id: number }) => unit.id === unitId)
        }
    })

    const toggleFavourite = (unitId) => {
        if (favouriteUnits.value.some((unit: { id: number }) => unit.id === unitId)) {
            removeFromFavourite(unitId)
            fetchFavouriteUnits()
        } else {
            addtoFavourite(unitId)
            fetchFavouriteUnits()
        }
    }

    const uploadBase64ImageToS3 = async (base64String, signedUrl, contentType = 'image/png') => {
        try {
            // Remove the data URL prefix if it exists (e.g., "data:image/png;base64,")
            const base64Data = base64String.includes('base64,')
                ? base64String.split('base64,')[1]
                : base64String

            // Convert base64 to binary data
            const binaryData = atob(base64Data)

            // Create an array buffer from the binary data
            const arrayBuffer = new ArrayBuffer(binaryData.length)
            const uint8Array = new Uint8Array(arrayBuffer)

            for (let i = 0; i < binaryData.length; i++) {
                uint8Array[i] = binaryData.charCodeAt(i)
            }

            // Create a Blob from the array buffer
            const blob = new Blob([uint8Array], { type: contentType })

            // Upload the blob using fetch and the signed URL
            const response = await fetch(signedUrl, {
                method: 'PUT',
                body: blob,
                headers: {
                    'Content-Type': contentType
                }
            })

            if (!response.ok) {
                throw new Error(`Upload failed with status: ${response.status}`)
            }

            // Extract the final URL by removing the query parameters from the signed URL
            const finalUrl = signedUrl.split('?')[0]

            return finalUrl
        } catch (error) {
            throw error
        }
    }

    const getFormattedDateTime = () => {
        const now = new Date()
        const year = now.getFullYear()
        const month = String(now.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const day = String(now.getDate()).padStart(2, '0')
        const hours = String(now.getHours()).padStart(2, '0')
        const minutes = String(now.getMinutes()).padStart(2, '0')
        const seconds = String(now.getSeconds()).padStart(2, '0')
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0')

        return `${year}${month}${day}-${hours}${minutes}${seconds}${milliseconds}`
    }

    const uploadForVisuadoCreate = async (fileContents, fileName) => {
        const filePath = `${fileName}-${getFormattedDateTime()}.png`
        const { $auth } = useNuxtApp()
        const { API_URL } = useAPI()
        const signedUrl = await $fetch(`${API_URL}/visuadoCreate/upload`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${($auth as { token: string }).token}`
            },
            body: {
                path: filePath
            }
        })

        const url = await uploadBase64ImageToS3(fileContents, signedUrl)
        const config = useRuntimeConfig()

        return `${config.public.visuadoCreateCdn}/${filePath}`
    }

    return {
        favouriteUnits,
        addtoFavourite,
        removeFromFavourite,
        fetchFavouriteUnits,
        isUnitFavourite,
        toggleFavourite,
        uploadForVisuadoCreate
    }
}
